/**
 * C4 skeleton: every non-sword art (fist, palm, claw, hand, dance, hidden weapons, staff) in the sample style
 * (sampleArt/arts/<art>.ts, built from families/handArtGen.ts). pp-wave stays on portPalm.ts; tf-supreme and bs-tempest
 * keep their own long-move FX.
 */
import { portArt } from './sampleArt/families/swordKit';
import { CLOUDPALM_FX } from './sampleArt/arts/cloudpalm';
import { TAIJIFIST_FX } from './sampleArt/arts/taijifist';
import { ARHATFIST_FX } from './sampleArt/arts/arhatfist';
import { BLISSPALM_FX } from './sampleArt/arts/blissclaw';
import { PRAJNAPALM_FX } from './sampleArt/arts/prajnapalm';
import { ARRESTHAND_FX } from './sampleArt/arts/arresthand';
import { DEMONDANCE_FX } from './sampleArt/arts/demondance';
import { SIXPULSE_FX } from './sampleArt/arts/sixpulse';
import { BLOODCLAW_FX } from './sampleArt/arts/bloodclaw';
import { DRAGONPALM_FX } from './sampleArt/arts/dragonpalm';
import { HIDDENARTS_FX } from './sampleArt/arts/hiddenarts';
import { GOLDENDRAGON_FX } from './sampleArt/arts/goldendragon';
import { TIDESTAFF_FX } from './sampleArt/arts/tidestaff';

for (const l of [CLOUDPALM_FX, TAIJIFIST_FX, ARHATFIST_FX, BLISSPALM_FX, PRAJNAPALM_FX, ARRESTHAND_FX, DEMONDANCE_FX, SIXPULSE_FX, BLOODCLAW_FX, DRAGONPALM_FX, HIDDENARTS_FX, GOLDENDRAGON_FX, TIDESTAFF_FX])
  portArt(l);
